module.exports = __webpack_public_path__ + "img/oil-production-white.915b24af.png";